function getRenderedSize(contains, cWidth, cHeight, width, height, pos){
  var oRatio = width / height,
  cRatio = cWidth / cHeight;
  var r = {};
  if (contains ? (oRatio > cRatio) : (oRatio < cRatio)) {
    r.width = cWidth;
    r.height = cWidth / oRatio;
  } else {
    r.width = cHeight * oRatio;
    r.height = cHeight;
  }
  r.left = (cWidth - r.width)*(pos/100);
  r.right = r.width + r.left;
  return r;
}

function getImgSizeInfo(img) {
  var pos = window.getComputedStyle(img).getPropertyValue('object-position').split(' ');
  return getRenderedSize(true,
    img.width,
    img.height,
    img.naturalWidth,
    img.naturalHeight,
    parseInt(pos[0]));
}

var maxPintsLen = 500;
function allowDrawing(canvas, attachMouseHandlers, drawCb) {
  function midPointBtw(p1, p2) {
    return {
      x: p1.x + (p2.x - p1.x) / 2,
      y: p1.y + (p2.y - p1.y) / 2
    };
  }

  function addPoint(e) {
    points.push({
      x: e.clientX - box.left,
      rx: (e.clientX - box.left) / box.width,
      y: e.clientY - box.top,
      ry: (e.clientY - box.top) / box.height,
    });

    if (points.length > maxPintsLen) {
      var diff = points.length - maxPintsLen;
      points.splice(0, diff);
    }

    drawCb(points);
  }

  function drawAll() {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    if (!points.length) {
      return;
    }

    var p1 = points[0];
    var p2 = points[1];

    ctx.beginPath();
    ctx.moveTo(p1.x, p1.y);

    for (var i = 1, len = points.length; i < len; i++) {
      // we pick the point between pi+1 & pi+2 as the
      // end point and p1 as our control point
      var midPoint = midPointBtw(p1, p2);
      ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
      p1 = points[i];
      p2 = points[i+1];
    }
    // Draw last line as a straight line while
    // we wait for the next point to be able to calculate
    // the bezier control point
    ctx.lineTo(p1.x, p1.y);
    ctx.lineWidth = 2;
    ctx.lineJoin = ctx.lineCap = 'round';
    ctx.stroke();
  }

  var el = canvas;
  var ctx = el.getContext('2d');
  var box = el.getBoundingClientRect();

  var isDrawing, points = [ ];

  if (attachMouseHandlers) {
    el.onmousedown = function(e) {
      isDrawing = true;
      box = el.getBoundingClientRect();
      addPoint(e);
      el.classList.add('is-drawing');
    };

    el.onmousemove = function(e) {
      if (!isDrawing) return;

      addPoint(e);
      drawAll();
    };

    document.onmouseup = function() {
      isDrawing = false;
      points.length = 0;
      el.classList.remove('is-drawing');
    };
  }

  $(el).on('update', function(ev, data) {
    box = el.getBoundingClientRect();

    var newpoints = (data || []).map(function(p) {
      return {
        x: p.rx * box.width,
        y: p.ry * box.height,
      };
    });
    [].splice.apply(points, [0, points.length].concat(newpoints));
    drawAll();
  });
}

function throttle(func, limit) {
  var inThrottle;
  return function() {
    var args = arguments;
    var context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(function() { inThrottle = false; }, limit);
    }
  };
}

module.exports = {
  getRenderedSize: getRenderedSize,
  getImgSizeInfo: getImgSizeInfo,
  allowDrawing: allowDrawing,
  throttle: throttle,
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/view-screenshare/slideshare/canvas-utils.js
 ** module id = 403
 ** module chunks = 0
 **/